const VIDEO_EXTENSIONS = [
  ".mp4",
  ".mov",
  ".webm",
  ".ogg",
  ".m4v",
  ".avi",
  ".mkv",
];

export const isVideo = (url: string): boolean => {
  const lower = url.toLowerCase();

  return VIDEO_EXTENSIONS.some((ext) => lower.includes(ext));
};

export default isVideo;
